import React, { Component }  from 'react';
import { Link } from 'react-router';

class logout extends Component {

  componentWillMount(){
    localStorage.clear();
  }
  render() {
    return (
      <div className="login-limiter">
        <div className="container-login100">
          <div className="wrap-login100">
            <div className="login100-form validate-form">
              <h1>نرم افزار مدیریت زمان هنگام</h1>
              <h4>
                خروج از سامانه با موفقیت انجام شد
              </h4>
              <Link id="login-again" to="/login">ورود دوباره</Link>
            </div>
            <div className="login100-more"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default logout;